<template>
    <div>
        <div class="title-box">
            场景信息列表
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-form-item prop="factoryId">
                <el-select v-model="queryParams.factoryId" filterable placeholder="选择工厂" clearable @change="getWorkshopByFactory">
                    <el-option
                    v-for="item in factoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="workshopId">
                <el-select v-model="queryParams.workshopId" filterable clearable placeholder="选择车间">
                    <el-option
                    v-for="item in workshopOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="sceneName">
                <el-input v-model="queryParams.sceneName" clearable placeholder="请输入场景名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="info" @click="onReset">重置</el-button>
            </el-form-item>
        </el-form>
        
        <!-- 表格 -->
        <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" class="custom-table-header">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column v-if="false" prop="id" label="id"></el-table-column>
            <el-table-column prop="sceneName" label="场景名称" width="200"  align="center"></el-table-column>
            <el-table-column prop="sceneTypeName" label="场景类型" width="80" align="center"></el-table-column>
            <el-table-column prop="factoryName" label="所属工厂" width="200" align="center"></el-table-column>
            <el-table-column prop="workshopName" label="所属车间" width="200" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column prop="updateByName" label="修改人" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button v-hasPermi="['enterpr:scene:edit']" style="color:#3083FB !important;" @click="handleEdit(scope.$index,scope.row)" type="text" size="small">修改</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!-- 添加 -->
        <el-dialog title="场景名称修改" :visible.sync="dialogFormVisible" width="620px" center :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="dialogForm" :rules="rules" label-width="80px" style="padding:0;" :inline="true">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="场景名称" prop="sceneName">
                            <el-input placeholder="请输入场景名称" v-model="dialogForm.sceneName" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="场景类型" prop="sceneType">
                            <el-select placeholder="请选择场景类型" v-model="dialogForm.sceneType" clearable filterable>
                                <el-option
                                v-for="item in sceneTypes"
                                :key="item.dictValue"
                                :label="item.dictLabel"
                                :value="item.dictValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remark">
                            <el-input placeholder="请输入备注" v-model="dialogForm.remark" clearable style="width:487px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" style="color:#000 !important;">取 消</el-button>
                <el-button type="primary" @click="handleAdd('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Message } from 'view-design';
export default {
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                factoryId:null,
                workshopId:null,
                sceneName:""
            },
            //工厂数据
            factoryOptions: [],
            // 车间数据
            workshopOptions:[],
            sceneTypes:[],
            total:0,
            tableHeight:650,
            // 表格数据
            tableData:[],
            multipleSelection:[],//选中的数据
            dialogFormVisible:false,//是否显示添加对话框
            dialogForm:{
                sceneName:"",
                sceneType:null,
                remark:""
            },
            multipleId:"",//选中数据的id
            multipleName:"",//选中数据的Name
            rules:{
                sceneName:[{ required: true, message: '场景名称不能为空', trigger: 'blur' }],
                sceneType:[{ required: true, message: '场景类型不能为空', trigger: 'change' }]
            }
        }
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.getList();
        this.getFactoryByCustomer();
        this.getSceneTypes();
    },
    methods: {
        // 获取场景信息列表
        getList(){
            this.$store.dispatch("scene/getSceneList",this.queryParams).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        // 根据客户查询工厂
        getFactoryByCustomer(){
            this.$store.dispatch("workshop/getFactoryByCustomer").then((result)=>{
                this.factoryOptions = result.data;
            });
        },
        // 根据工厂查询车间
        getWorkshopByFactory(){
            this.$store.dispatch("scene/getWorkshopByFactory",{factoryId:this.queryParams.factoryId}).then((result)=>{
                this.queryParams.workshopId = null;
                if(result&& result.data&& result.data.length>0){
                    this.workshopOptions = result.data;
                }
                else{
                    this.workshopOptions = [];
                }
            });
        },
        getSceneTypes(){
            this.$store.dispatch("scene/getSceneTypes").then((result)=>{
                this.sceneTypes = result.data;
            });
        },
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化
            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置查询条件
        onReset(){
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                factoryId:null,
                workshopId:null,
                sceneName:""
            };
            this.getList();
        },
        // 表单重置
        reset(){
            this.dialogForm = {
                sceneName:"",
                sceneType:null,
                remark:""
            };
        },
        // 行修改
        handleEdit(index,row) {
            this.dialogFormVisible = true;
            this.reset();
            this.$store.dispatch('scene/getScene',{id:row.id}).then((result)=>{
                if(result){
                    // this.dialogForm = result.data;
                    Object.assign(this.dialogForm, result.data);
                    this.dialogForm.sceneType = result.data.sceneType.toString();
                }
            });
        },
        // 确认
        handleAdd(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$store.dispatch("scene/editScene",this.dialogForm).then((res)=>{
                        this.getList();
                    }).catch(ex=>{
                        Message.error(ex);
                    });
                    this.dialogFormVisible = false;
                } else {
                    return false;
                }
            });
            
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    .el-row{
        padding-bottom: 10px;
    }
    ::v-deep .el-form-item__error{
        padding-top: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    ::v-deep .el-dialog{
        border-radius: 5px;
    }
    ::v-deep .el-dialog__header {
        padding: 6px 19px;
        background: #B1CEF9;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }   
    ::v-deep .el-dialog__headerbtn {
        font-size: 18px;
    }
    ::v-deep .el-dialog__headerbtn {
        top: 10px;
        right: 6px;
    }
    ::v-deep .el-dialog__body {
        padding: 15px 20px;
        border-bottom: 1px solid #D5D5D5;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-dialog__footer {
        padding: 20px;
    }
    ::v-deep .el-table__body-wrapper{
        height: 100%;
        overflow-y: auto;
    }
</style>